import {
  ElementRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BusinessUnitSummary } from '@models/business-unit.interface';

@Component({
  selector: 'app-business-unit-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './business-unit-list.component.html',
  styleUrl: './business-unit-list.component.scss'
})
export class BusinessUnitListComponent implements OnChanges {
  private readonly hostElement = inject(ElementRef<HTMLElement>);

  @Input() businessUnits: BusinessUnitSummary[] = [];
  @Input() selectedId: number | null = null;
  @Input() newlyCreatedId: number | null = null;

  @Output() businessUnitSelected = new EventEmitter<BusinessUnitSummary>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['name', 'alias', 'actions'];

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['selectedId'] && !changes['businessUnits']) return;

    setTimeout(() => this.scrollToSelectedRow());
  }

  onRowClick(businessUnit: BusinessUnitSummary): void {
    this.businessUnitSelected.emit(businessUnit);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onDeleteClick(businessUnit: BusinessUnitSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(businessUnit.id);
  }

  private scrollToSelectedRow(): void {
    if (this.selectedId === null) return;

    const row = this.hostElement.nativeElement.querySelector(
      `tr[data-business-unit-id="${this.selectedId}"]`
    ) as HTMLElement | null;

    row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
